import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import {
  getTXCenterProvidersApiUrl,
  NewLogisticProvidersFormBody,
  PatchLogisticProvidersFormBody,
  LogisticProvider,
  PaginatedLogisticProviderListFilters,
} from '@/api/apis/facilities';

const getTXCenterProvidersList = async (params: PaginatedLogisticProviderListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<LogisticProvider>>(getTXCenterProvidersApiUrl.list(), { params });
  return res.data.data;
};

const getTXCenterProvidersById = async (txCenterId: string): Promise<LogisticProvider> => {
  const res = await http.get<ApiResponseBody<LogisticProvider>>(
    getTXCenterProvidersApiUrl.logisticProviderById(txCenterId),
  );
  return res.data.data;
};

const updateTXCenterProviderById = async ({ id, ...body }: PatchLogisticProvidersFormBody & { id: string }) => {
  const res = await http.patch<ApiResponseBody<LogisticProvider>>(
    getTXCenterProvidersApiUrl.logisticProviderById(id),
    body,
  );
  return res.data.data;
};

const removeTXCenterProviderById = async (txCenterId: string): Promise<{ message: string }> => {
  const res = await http.delete<ApiResponseBody<{ message: string }>>(
    getTXCenterProvidersApiUrl.logisticProviderById(txCenterId),
  );
  return res.data.data;
};

const createTXCenterProvider = async (body: NewLogisticProvidersFormBody & { id: string }) => {
  const res = await http.post<ApiResponseBody<LogisticProvider>>(getTXCenterProvidersApiUrl.list(), body);
  return res.data.data;
};

export const txCenterProvidersApiFetcher = {
  getTXCenterProvidersList,
  getTXCenterProvidersById,
  updateTXCenterProviderById,
  removeTXCenterProviderById,
  createTXCenterProvider,
};
